import firebase from "firebase/app";
import { getUserInfo } from "./getUserInfo";

export const getFollowing = async (currentUserId) => {
  const followingDocs = [];

  // fetch every user I follow
  const snapshotQuery = await firebase
    .firestore()
    .collection("followers")
    .where("followers", "array-contains", currentUserId)
    .orderBy("lastActivity", "desc")
    .get();

  if (snapshotQuery.empty) {
    return [];
  }

  snapshotQuery.forEach(async (doc) => {
    if (doc.exists) {
      const userId = doc.id;
      const userDoc = getUserInfo(userId);

      userDoc && followingDocs.push(userDoc);
    }
  });

  return (await Promise.all(followingDocs)).filter((user) => user !== null);
};

export const getFollower = async (currentUserId) => {
  // fetch all users that follow me
  const currentUserSnapshot = await firebase
    .firestore()
    .collection("followers")
    .doc(currentUserId)
    .get();

  const currentUserDoc = currentUserSnapshot.data();

  const followerDocs = currentUserDoc.followers.map(async (userId) => {
    const userDoc = getUserInfo(userId);
    return userDoc;
  });

  return (await Promise.all(followerDocs)).filter((user) => user !== null);
};

export const getFollowerData = async (currentUserId) => {
  const following = await getFollowing(currentUserId);
  const follower = await getFollower(currentUserId);

  return {
    following,
    follower,
  };
};

export const getFollowingActivities = async (followingUser, docStart, lastIndex, currentUser) => {
  const followingPublicUser = followingUser.filter((user) => user?.private === false);
  if (!followingPublicUser.find((user) => user.id === currentUser.id)) {
    followingPublicUser.push(currentUser);
  }

  let followingDocsSnapshot = followingPublicUser.map(async (user) => {
    return await firebase.firestore().collection("followers").doc(user.id).get();
  });

  const followingDocsResolved = await Promise.all(followingDocsSnapshot);

  const followingDocs = followingDocsResolved.map((doc) => {
    return {
      userId: doc.id,
      ...doc.data(),
    };
  });

  const followingActivities = [];

  followingDocs.forEach((followingDoc) => {
    followingDoc.recentActivity.forEach((activity) => {
      followingActivities.push(activity);
    });
  });

  followingActivities.sort((a, b) => (a.date < b.date && 1) || -1);

  const activityDocsSnapshot = followingActivities
    .slice(docStart, lastIndex)
    .map(
      async (followingActivity) =>
        await firebase.firestore().collection("activities").doc(followingActivity.activityID).get()
    );
  const activityDocsResolved = await Promise.all(activityDocsSnapshot);

  if (activityDocsResolved.every((data) => data.empty)) {
    return { activityDocs: [], lastIndex, noNextData: true };
  }

  const activityDocs = activityDocsResolved.map((doc) => {
    const userData = followingPublicUser.find((user) => doc.data().userID === user.id);

    return {
      docId: doc.id,
      userName: userData.userName,
      photoUrl: userData.photoUrl,
      ...doc.data(),
    };
  });

  const noNextData = followingActivities.length < lastIndex + 1;

  return { activityDocs, lastIndex, noNextData };
};
